export class GoogleWorkspaceUserRestoreWorkload {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "GoogleWorkspaceUserRestoreWorkloadType",
            "format": ""
        },
        {
            "name": "gmail",
            "baseName": "gmail",
            "type": "GoogleWorkspaceGmailRestoreOptions",
            "format": ""
        },
        {
            "name": "drive",
            "baseName": "drive",
            "type": "GoogleWorkspaceDriveRestoreOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUserRestoreWorkload.attributeTypeMap;
    }
    constructor() {
    }
}
